import { List } from "immutable";

import { CourseId } from "../models/state/courses/course/Course";
import { SectionId, Sections } from "../models/state/sections/Sections";
import * as sectionsSelectors from "./state/sections";

export function getSectionAndItsParentsIdsWithoutCourse(
  sections: Sections,
  courseId: CourseId,
  sectionId: SectionId
): List<SectionId> {
  const parentId = sectionsSelectors.getSectionParentId(sections, sectionId);

  if (!parentId || parentId === courseId) {
    return List([sectionId]);
  }

  return getSectionAndItsParentsIdsWithoutCourse(
    sections,
    courseId,
    parentId
  ).concat(List([sectionId]));
}

export function getSectionAndItsParentsNamesWithoutCourse(
  sections: Sections,
  courseId: string,
  sectionId: string
): List<string> {
  return getSectionAndItsParentsIdsWithoutCourse(
    sections,
    courseId,
    sectionId
  ).map((sectionId: string) =>
    sectionsSelectors.getSectionTitle(sections, sectionId)
  );
}
